

<template>
    <Transition name="scroll-y-reverse-transition" mode="out-in">
        <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->

        <v-container class="text--white" dark id="home-container">
            <auth></auth>
            <v-tabs v-model="view_tab" centered center-active show-arrows background-color="backdrop">
                <v-tab>
                    All Cases
                </v-tab>
                <v-tab>
                    My Assignments
                </v-tab>
                <v-tab>
                    My Favorites
                </v-tab>
                <v-tab>
                    Users
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="view_tab">
                <v-tab-item>
                    <!--Incident Table-->
                    <hitnruntable @newIncident="openNewIncidentDialog" ref="incidentTable"
                                  @openFiltersDialog="openFiltersDialog"
                                  :hideSearch="false"
                                  :filter_text="filter_text"
                                  @openIncidentLogs="openIncidentLogs"
                                  @optionsChanged="incidentOptionsChanged"
                                  @editIncident="openEditIncidentDialog"
                                  :data="incidenttable.data"
                                  :serverTotalCount="incidenttable.servertotal"
                                  :loading="incidenttable.loading"
                                  :Prop_searchfield="field_filters.searchfield"
                                  @refreshData="refreshAllIncidentData"
                                  @searchFieldUpdated="searchFieldUpdated"
                                  @SearchIncidents="getIncidentData"
                                  @printVictimLetter="printVictimLetter"
                                  @printSuspectLetter="printSuspectLetter"
                                  @printEnvelope="printEnvelope">

                    </hitnruntable>
                </v-tab-item>
                <v-tab-item>
                    <!--My Assignments Table-->
                    <hitnruntable @newIncident="openNewIncidentDialog" @editIncident="openEditIncidentDialog" @openIncidentLogs="openIncidentLogs"
                                  :hideSearch="true" :filter_text="[]" @optionsChanged="assignmentsOptionsChanged"
                                  :data="assignmentstable.data"
                                  :serverTotalCount="assignmentstable.servertotal"
                                  :loading="assignmentstable.loading"
                                  @refreshData="refreshAllIncidentData"
                                  @printVictimLetter="printVictimLetter"
                                  @printSuspectLetter="printSuspectLetter"
                                  @printEnvelope="printEnvelope">

                    </hitnruntable>
                </v-tab-item>
                <v-tab-item>
                    <!--My Favorites Table-->
                    <hitnruntable @newIncident="openNewIncidentDialog" @editIncident="openEditIncidentDialog" @openIncidentLogs="openIncidentLogs"
                                  :hideSearch="true" :filter_text="[]" @optionsChanged="favoriteOptionsChanged"
                                  :data="favoritestable.data"
                                  :serverTotalCount="favoritestable.servertotal"
                                  :loading="favoritestable.loading"
                                  @refreshData="refreshAllIncidentData"
                                  @printVictimLetter="printVictimLetter"
                                  @printSuspectLetter="printSuspectLetter"
                                  @printEnvelope="printEnvelope">

                    </hitnruntable>
                </v-tab-item>
                <v-tab-item>
                    <usertable @newUser="openNewUserDialog"
                               @editUser="openEditUserDialog"
                               :data="usertable.data"
                               @optionsChanged="usersOptionsChanged"
                               :serverTotalCount="usertable.servertotal"
                               :loading="usertable.loading"
                               @refreshData="refreshAllIncidentAndUserData">

                    </usertable>
                </v-tab-item>
            </v-tabs-items>

            <!--{{$store.state.user.email}}-->
            <!--IncidentDialog-->
            <hitnrundialog v-if="incident_dialog" @closeDialog="closeIncidentDialog" @refreshData="refreshAllIncidentData" :incident_dialog_ID="incident_dialog_ID"></hitnrundialog>
            <!--Userdialog-->
            <userdialog v-if="user_dialog" @closeDialog="closeUserDialog" @refreshData="refreshAllIncidentAndUserData" :user_dialog_ID="user_dialog_ID"></userdialog>
            <!--filtersialog-->
            <filtersdialog v-if="filters_dialog" @closeDialog="closeFiltersDialog" @applyFilters="applyFilters" :field_filters="field_filters" @resetFilters="resetFilters"
                           @filterTextUpdated="filter_text_update"></filtersdialog>
            <!--logsDialog-->
            <logsdialog v-if="logs_dialog" @closeDialog="closeIncidentLogs" :logs_dialog_ID="logs_dialog_ID"></logsdialog>
            <!--Printables-->
            <printables ref="printables" :vic_ltr_data="printables_data.vic_ltr_data" :sus_ltr_data="printables_data.sus_ltr_data" :envelope_data="printables_data.envelope_data">

            </printables>


        </v-container>

    </Transition>
</template>

<style lang="scss" scoped>
    @import "../scss/site.scss";

    #home-container {
        max-width: 1068px;
        height: auto;
        padding: 0px;
    }

    .fab-container {
        position: fixed;
        bottom: 0;
        right: 0;
    }
</style>

<script>
    /* eslint-disable */
    import { bus_common } from "../mixins/bus_common";
    import auth from "./auth.vue";
    import hitnruntable from "./hitnrun-table";
    import hitnrundialog from "./hitnrun-dialog";
    import usertable from "./users-table";
    import userdialog from "./user-dialog";
    import filtersdialog from "./filters-dialog";
    import logsdialog from "./logs-dialog";
    import printables from "./printables";
    export default {
        name: "Home",
        mixins: [bus_common],
        components: {
            auth, hitnruntable, hitnrundialog, usertable, userdialog, filtersdialog, logsdialog,
            printables
        },
        data() {
            return {
                incident_dialog: false,
                user_dialog: false,
                user_dialog_ID: 0,
                filters_dialog: false,
                logs_dialog: false,
                view_tab: null,
                field_filters: {
                    searchfield: "",
                    deleted: "NO",
                    status: "",
                    assigned: "",
                    priority: "",
                    sus_DOB: "",
                    incident_date_start: "",
                    incident_date_end: "",
                    modified_date_start: "",
                    modified_date_end: "",
                    assigned_date_start: "",
                    assigned_date_end: "",
                    closed_date_start: "",
                    closed_date_end: "",
                    favorites_view: false,
                    myassignments_view: false,
                    user_email: this.$store.state.user.email,
                },
                filter_text: "",
                usertable: {
                    data: [],
                    servertotal: 0,
                    pagesize: 10,
                    page: 1,
                    sortby: [],
                    sortdesc: [],
                    loading: false,
                },
                incidenttable: {
                    data: [],
                    servertotal: 0,
                    pagesize: 10,
                    page: 1,
                    sortby: [],
                    sortdesc: [],
                    loading: false,
                },
                incident_dialog_ID: 0,
                assignmentstable: {
                    data: [],
                    servertotal: 0,
                    pagesize: 10,
                    page: 1,
                    sortby: [],
                    sortdesc: [],
                    loading: false,
                },
                favoritestable: {
                    data: [],
                    servertotal: 0,
                    pagesize: 10,
                    page: 1,
                    sortby: [],
                    sortdesc: [],
                    loading: false,
                },
                logs_dialog_ID: 0,
                printables_data: {
                    vic_ltr_data: {
                        vic_name: "",
                        vic_address: "",
                        vic_city: "",
                        vic_state: "",
                        vic_zip: "",
                        today_date: "",
                        case_num: "",
                        driver_name: "",
                        reg_owner_name: "",
                        veh_year: "",
                        veh_make: "",
                        veh_model: "",
                        veh_lic: "",
                        veh_state: "",
                        ins_name: "",
                        ins_policy_num: "",
                        ins_phone: "",
                        det_phone: "",
                        det_sig_image: "",
                    },
                    sus_ltr_data: {
                        case_num: ""
                    },
                    envelope_data: {
                        sus_name: "",
                        sus_address: "",
                        sus_city: "",
                        sus_state: "",
                        sus_zip: "",
                    },
                }
            }
        },
        watch: {
            "$store.state.user.email": function () {
                let self = this;
                if (this.$store.state.user.email.length > 0) {
                    this.field_filters.user_email = this.$store.state.user.email;
                    this.init()
                }
            }
        },
        methods: {

            // Init / General
            init() {
                this.getUserData();
                this.getIncidentData();
                this.getAssignmentData();
                this.getFavoriteData();
            },
            fixEmptyDate(object, propname) {
                if (object[propname] == "")
                    object[propname] = '1900-01-01'
            },
            UndoEmptyDateFix(object, propname) {
                if (object[propname] == '0001-01-01T00:00:00' || object[propname] == "1900-01-01T00:00:00")
                    object[propname] = "None"
                else {
                    object[propname] = this.$moment(new Date(object[propname])).format("MM-DD-YYYY")
                }
            },
            refreshAllIncidentData() {
                this.getIncidentData();
                this.getAssignmentData();
                this.getFavoriteData();
            },
            searchFieldUpdated(searchfield) {
                this.field_filters.searchfield = searchfield;
            },

            // Filter dialog methods
            openFiltersDialog() {
                this.$refs.incidentTable.$refs.searchField.blur();
                setTimeout(() => this.filters_dialog = true, 25)
            },
            closeFiltersDialog() {
                this.filters_dialog = false;
            },
            resetFilters() {
                this.field_filters = {
                    searchfield: "",
                    deleted: "NO",
                    status: "",
                    assigned: "",
                    sus_DOB: "",
                    priority: "",
                    incident_date_start: "",
                    incident_date_end: "",
                    modified_date_start: "",
                    modified_date_end: "",
                    assigned_date_start: "",
                    assigned_date_end: "",
                    closed_date_start: "",
                    closed_date_end: "",
                    favorites_view: false,
                    myassignments_view: false,
                    user_email: this.$store.state.user.email,
                };

                this.$refs.incidentTable.ClearSearch();
                this.getIncidentData();
            },
            filter_text_update(val) {
                this.filter_text = val
            },
            applyFilters() {
                this.filters_dialog = false;
                this.getIncidentData();
            },

            // Logs dialog methods
            openIncidentLogs(hitrunID) {
                this.logs_dialog_ID = hitrunID;
                this.logs_dialog = true;
            },
            closeIncidentLogs() {
                this.logs_dialog = false;
            },

            // User table/dialog methods
            openNewUserDialog() {
                this.user_dialog_ID = 0;
                this.user_dialog = true;
            },
            closeUserDialog() {
                this.user_dialog = false;
            },
            openEditUserDialog(hitnrun_usersId) {
                this.user_dialog_ID = hitnrun_usersId;
                this.user_dialog = true;
            },
            usersOptionsChanged(event) {
                this.usertable.pagesize = event.itemsPerPage;
                this.usertable.page = event.page;
                this.usertable.sortby = event.sortBy;
                this.usertable.sortdesc = event.sortDesc;
                this.getUserData();
            },
            async getUserData() {
                this.usertable.loading = true;
                let form = {
                    page: this.usertable.page,
                    pageSize: this.usertable.pagesize,
                    sortBy: this.usertable.sortby,
                    sortDesc: this.usertable.sortdesc
                };

                await this.$axios.post('api/hitnrunuser/getUsers', form)
                    .then(response => {
                        this.usertable.data = [];
                        this.usertable.data = response.data.lst_users;
                        this.usertable.servertotal = response.data.serverTotalCount;

                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                        }
                    });
                this.usertable.loading = false;
            },
            async refreshAllIncidentAndUserData() {
                this.getUserData();
                this.refreshAllIncidentData();
            },

            // Incident table/ dialog methods
            openNewIncidentDialog() {
                this.incident_dialog_ID = 0;
                this.incident_dialog = true;
            },
            openEditIncidentDialog(hitrunID) {
                this.incident_dialog_ID = hitrunID;
                this.incident_dialog = true;
            },
            closeIncidentDialog() {
                this.incident_dialog = false;
            },
            async getIncidentData() {

                this.incidenttable.loading = true;

                //Fix any empty search dates here
                let SearchFormCopy = JSON.parse(JSON.stringify(this.field_filters));
                this.fixEmptyDate(SearchFormCopy, 'sus_DOB')
                this.fixEmptyDate(SearchFormCopy, 'incident_date_start')
                this.fixEmptyDate(SearchFormCopy, 'incident_date_end')
                this.fixEmptyDate(SearchFormCopy, 'modified_date_start')
                this.fixEmptyDate(SearchFormCopy, 'modified_date_end')
                this.fixEmptyDate(SearchFormCopy, 'assigned_date_start')
                this.fixEmptyDate(SearchFormCopy, 'assigned_date_end')
                this.fixEmptyDate(SearchFormCopy, 'closed_date_start')
                this.fixEmptyDate(SearchFormCopy, 'closed_date_end')

                let form = {
                    searchForm: SearchFormCopy,
                    page: this.incidenttable.page,
                    pageSize: this.incidenttable.pagesize,
                    sortBy: this.incidenttable.sortby,
                    sortDesc: this.incidenttable.sortdesc
                };

                await this.$axios.post('api/hitnrun/getIncidents', form)
                    .then(response => {
                        this.incidenttable.data = [];
                        this.incidenttable.data = response.data.lst_incidents;
                        this.incidenttable.servertotal = response.data.serverTotalCount;
                        this.fixDatesForIncidentTable();

                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                        }
                    });
                this.incidenttable.loading = false;

            },
            incidentOptionsChanged(event) {
                this.incidenttable.pagesize = event.itemsPerPage;
                this.incidenttable.page = event.page;
                this.incidenttable.sortby = event.sortBy;
                this.incidenttable.sortdesc = event.sortDesc;
                this.getIncidentData();
            },
            fixDatesForIncidentTable() {
                for (var i = 0; i < this.incidenttable.data.length; i++) {
                    this.UndoEmptyDateFix(this.incidenttable.data[i], 'assigned_date');
                    this.UndoEmptyDateFix(this.incidenttable.data[i], 'incident_date');
                    this.UndoEmptyDateFix(this.incidenttable.data[i], 'closed_date');
                }
            },

            // Assignment Table
            async getAssignmentData() {

                // No filters allowed here so provided empty form except assigment data needed
                let field_form = {
                    searchfield: "",
                    deleted: "NO",
                    status: "",
                    assigned: "",
                    sus_DOB: "",
                    incident_date_start: "",
                    incident_date_end: "",
                    modified_date_start: "",
                    modified_date_end: "",
                    assigned_date_start: "",
                    assigned_date_end: "",
                    closed_date_start: "",
                    closed_date_end: "",
                    favorites_view: false,
                    myassignments_view: true,
                    user_email: this.$store.state.user.email,
                };

                this.assignmentstable.loading = true;

                //Fix any empty search dates here
                let SearchFormCopy = JSON.parse(JSON.stringify(field_form));
                this.fixEmptyDate(SearchFormCopy, 'sus_DOB')
                this.fixEmptyDate(SearchFormCopy, 'incident_date_start')
                this.fixEmptyDate(SearchFormCopy, 'incident_date_end')
                this.fixEmptyDate(SearchFormCopy, 'modified_date_start')
                this.fixEmptyDate(SearchFormCopy, 'modified_date_end')
                this.fixEmptyDate(SearchFormCopy, 'assigned_date_start')
                this.fixEmptyDate(SearchFormCopy, 'assigned_date_end')
                this.fixEmptyDate(SearchFormCopy, 'closed_date_start')
                this.fixEmptyDate(SearchFormCopy, 'closed_date_end')

                let form = {
                    searchForm: SearchFormCopy,
                    page: this.assignmentstable.page,
                    pageSize: this.assignmentstable.pagesize,
                    sortBy: this.assignmentstable.sortby,
                    sortDesc: this.assignmentstable.sortdesc
                };

                await this.$axios.post('api/hitnrun/getIncidents', form)
                    .then(response => {
                        this.assignmentstable.data = [];
                        this.assignmentstable.data = response.data.lst_incidents;
                        this.assignmentstable.servertotal = response.data.serverTotalCount;
                        this.fixDatesForAssingmentTable();

                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                        }
                    });
                this.assignmentstable.loading = false;

            },
            fixDatesForAssingmentTable() {
                for (var i = 0; i < this.assignmentstable.data.length; i++) {
                    this.UndoEmptyDateFix(this.assignmentstable.data[i], 'assigned_date');
                    this.UndoEmptyDateFix(this.assignmentstable.data[i], 'incident_date');
                    this.UndoEmptyDateFix(this.assignmentstable.data[i], 'closed_date');
                }
            },
            assignmentsOptionsChanged(event) {
                this.assignmentstable.pagesize = event.itemsPerPage;
                this.assignmentstable.page = event.page;
                this.assignmentstable.sortby = event.sortBy;
                this.assignmentstable.sortdesc = event.sortDesc;
                this.getAssignmentData();
            },

            // Favorite Table
            async getFavoriteData() {

                // No filters allowed here so provided empty form except favorite data needed
                let field_form = {
                    searchfield: "",
                    deleted: "NO",
                    status: "",
                    assigned: "",
                    sus_DOB: "",
                    incident_date_start: "",
                    incident_date_end: "",
                    modified_date_start: "",
                    modified_date_end: "",
                    assigned_date_start: "",
                    assigned_date_end: "",
                    closed_date_start: "",
                    closed_date_end: "",
                    favorites_view: true,
                    myassignments_view: false,
                    user_email: this.$store.state.user.email,
                };

                this.favoritestable.loading = true;

                //Fix any empty search dates here
                let SearchFormCopy = JSON.parse(JSON.stringify(field_form));
                this.fixEmptyDate(SearchFormCopy, 'sus_DOB')
                this.fixEmptyDate(SearchFormCopy, 'incident_date_start')
                this.fixEmptyDate(SearchFormCopy, 'incident_date_end')
                this.fixEmptyDate(SearchFormCopy, 'modified_date_start')
                this.fixEmptyDate(SearchFormCopy, 'modified_date_end')
                this.fixEmptyDate(SearchFormCopy, 'assigned_date_start')
                this.fixEmptyDate(SearchFormCopy, 'assigned_date_end')
                this.fixEmptyDate(SearchFormCopy, 'closed_date_start')
                this.fixEmptyDate(SearchFormCopy, 'closed_date_end')

                let form = {
                    searchForm: SearchFormCopy,
                    page: this.favoritestable.page,
                    pageSize: this.favoritestable.pagesize,
                    sortBy: this.favoritestable.sortby,
                    sortDesc: this.favoritestable.sortdesc
                };

                await this.$axios.post('api/hitnrun/getIncidents', form)
                    .then(response => {
                        this.favoritestable.data = [];
                        this.favoritestable.data = response.data.lst_incidents;
                        this.favoritestable.servertotal = response.data.serverTotalCount;
                        this.fixDatesForFavoriteTable();

                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                        }
                    });
                this.favoritestable.loading = false;

            },
            fixDatesForFavoriteTable() {
                for (var i = 0; i < this.favoritestable.data.length; i++) {
                    this.UndoEmptyDateFix(this.favoritestable.data[i], 'assigned_date');
                    this.UndoEmptyDateFix(this.favoritestable.data[i], 'incident_date');
                    this.UndoEmptyDateFix(this.favoritestable.data[i], 'closed_date');
                }
            },
            favoriteOptionsChanged(event) {
                this.favoritestable.pagesize = event.itemsPerPage;
                this.favoritestable.page = event.page;
                this.favoritestable.sortby = event.sortBy;
                this.favoritestable.sortdesc = event.sortDesc;
                this.getFavoriteData();
            },

            //Printables functions
            printVictimLetter(victim_letter_data) {
                this.printables_data.vic_ltr_data = victim_letter_data;
                this.$nextTick(() => {
                    this.$refs.printables.printVictimLetter()
                });
            },

            printSuspectLetter(suspect_letter_data) {
                this.printables_data.sus_ltr_data = suspect_letter_data;
                this.$nextTick(() => {
                    this.$refs.printables.printSuspectLetter()
                });
            },

            printEnvelope(envelope_data) {
                this.printables_data.envelope_data = envelope_data;
                this.$nextTick(() => {
                    this.$refs.printables.printEnvelope()
                });
            }
        },
        mounted() {
            var self = this;
            this.$nextTick(() => {
                this.init();

            });
        },
    };
</script>
